import { useQuery } from 'react-query';
import { getVideo } from 'lib/api';

type Props = {
  videoId: number;
};

export const useGetVideo = ({ videoId }: Props) => {
  return useQuery(['video', videoId], async () => getVideo(videoId), {
    refetchOnMount: true,
  });
};
